/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';

import {
  getProperties,
  getEnabledProperties,
  setEnabledProperties,
  selectIsPending,
} from '../../store/companySlice';

import {
  setMessage,
} from '../../store/authSlice';

import {
  isRequired,
  validateField,
  validateForm,
} from '../../helpers/validation';

const useStyles = makeStyles((theme) => ({
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function EditPropertiesForm({
  companyId,
  clientId,
  callback,
  open,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [properties, setProperties] = useState([]);
  const isPending = useSelector(selectIsPending);
  const [formErrors, setFormErrors] = useState({});
  const [formValues, setFormValues] = useState({
    selectedProperties: {},
  });

  const formRules = {
    selectedProperties: [isRequired],
  };

  const handleChangeProperty = (event, property) => {
    const { ...selectedProperties } = formValues.selectedProperties;

    if (event.target.checked) {
      selectedProperties[property.id] = {
        id: property.id,
        code: property.code,
        title: property.title,
      };
    } else {
      delete selectedProperties[property.id];
    }

    setFormValues({ ...formValues, selectedProperties });
  };

  const handleBlur = (event) => {
    validateField(formRules, formErrors, setFormErrors, event.target.name, event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (validateForm(formRules, formValues, formErrors, setFormErrors)) {
      dispatch(setEnabledProperties({
        companyId,
        selectedProperties: Object.values(formValues.selectedProperties),
      }))
        .unwrap()
        .then(() => {
          dispatch(setMessage({ message: 'Properties updated', severity: 'success' }));
          if (callback) callback();
        })
        .catch(() => {
          dispatch(setMessage({ message: 'Properties could not be updated', severity: 'error' }));
        });
    } else {
      dispatch(setMessage({ message: 'Properties could not be updated', severity: 'error' }));
    }
  };

  useEffect(() => {
    async function fetchProperties() {
      if (open && clientId && companyId) {
        const companyProperties = await dispatch(getProperties({ clientId })).unwrap();
        const enabledProperties = await dispatch(getEnabledProperties({ companyId })).unwrap();

        if (companyProperties) {
          setProperties(companyProperties);
        } else {
          setProperties([]);
        }

        if (enabledProperties && enabledProperties.length > 0) {
          setFormValues({
            ...formValues,
            selectedProperties: enabledProperties
              .reduce((selectedProperties, property) => {
                selectedProperties[property.id] = {
                  id: property.id,
                  code: property.code,
                  title: property.title,
                };

                return selectedProperties;
              }, {}),
          });
        }
      }
    }

    fetchProperties();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, clientId, companyId, open]);

  return (
    <form className={classes.form}>
      <FormGroup>
        {properties && properties.map((property) => (
          <FormControlLabel
            control={(
              <Checkbox
                checked={!!formValues.selectedProperties[property.id]}
                onChange={(event) => {
                  handleChangeProperty(event, property);
                }}
                onBlur={handleBlur}
                disabled={isPending}
                name={property.title}
                color="primary"
              />
          )}
            label={property.title}
          />
        ))}
      </FormGroup>
      <Button
        type="submit"
        variant="contained"
        color="primary"
        className={classes.submit}
        onClick={handleSubmit}
        disabled={isPending}
        fullWidth
      >
        Submit
      </Button>
    </form>
  );
}
